import type { TicketDetail } from '@easyhelp/shared';
import { ContextAttachments } from './ContextAttachments';
import { DetailSection, FactList, type Fact } from './DetailSection';

const NOT_COLLECTED = 'Non rilevato';

/**
 * Contesto raccolto all'invio (contratto §5.1, §5.2; PRD-005 US-1): schermata segnalata, percorso,
 * riferimento al record («Segnalazione di evento · 1234», DEC-014) e identificativo paziente dei
 * ticket EasyCare, entrambi solo se conservati, cioè se la regola «riferimento al record consentito»
 * del committente era attiva alla ricezione, dati tecnici e, sotto, presenza o assenza di schermata e
 * log con il visore (story #8). Ruolo e unità operativa sono nel blocco del segnalante, consumer,
 * committente e canale nella provenienza.
 */
export function TicketContextSection({ ticket }: { ticket: Pick<TicketDetail, 'code' | 'context' | 'channel'> }) {
  const { context } = ticket;
  const facts: Fact[] = [];
  if (ticket.channel === 'in-piattaforma') {
    facts.push(
      { label: 'Schermata', value: context.screenLabel, missing: NOT_COLLECTED },
      { label: 'Percorso', value: context.routePattern, missing: NOT_COLLECTED }
    );
  }
  if (context.recordReference) {
    const { label, id } = context.recordReference;
    facts.push({ label: 'Riferimento al record', value: `${label} · ${id}` });
  }
  if (context.patientIdentifier) facts.push({ label: 'Identificativo paziente', value: context.patientIdentifier });
  facts.push(
    { label: 'Browser', value: context.browser, missing: NOT_COLLECTED },
    { label: 'Sistema operativo', value: context.os, missing: NOT_COLLECTED },
    { label: 'Versione applicativa', value: context.appVersion },
    { label: 'User agent', value: context.userAgent },
    { label: 'Correlation id', value: context.correlationId, missing: NOT_COLLECTED }
  );
  return (
    <DetailSection title="Contesto raccolto all'invio">
      <FactList facts={facts} />
      {/* `key`: visori, esiti ed URL `blob:` restano del ticket su cui sono stati aperti. */}
      <ContextAttachments key={ticket.code} ticket={ticket} />
    </DetailSection>
  );
}
